
function FinancesPaymentMethod(obj) {
    this.id  = (obj.id || null);
    this.name = (obj.string || null);
}

module.exports = FinancesPaymentMethod;